<template>
  <span>
    <v-dialog v-model="dialog" max-width="650" persistent scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="bg-primary-gradient primary" v-bind="attrs" v-on="on">
          <v-icon class="mr-3">{{ icons.delete }}</v-icon>
          Delete User Profile
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <h4 class="mb-1">Delete User Data</h4>
        </v-card-title>

        <v-divider class="mb-5" />

        <v-card-text class="my-3">
          <v-alert type="warning" outlined class="mb-4">
            <strong>Warning:</strong> This action will permanently remove all
            Personally Identifiable Information (PII) data for this user. The
            user will no longer be able to login or access the app.
          </v-alert>

          <p class="body-1 mb-4">
            To confirm deletion, please type <strong>"Delete"</strong> in the
            field below:
          </p>

          <v-text-field
            v-model="confirmationText"
            label="Type 'Delete' to confirm"
            autocomplete="off"
            :error-messages="confirmationError"
            @input="clearError"
            outlined
            flat
          />
        </v-card-text>

        <v-divider class="mb-3" />

        <v-card-actions class="px-5 pb-5">
          <v-spacer />

          <v-btn
            color="warning"
            :loading="isDeleting"
            @click="closeDialog"
            text
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            :loading="isDeleting"
            :disabled="!isDeleteEnabled"
            @click="confirmDelete"
            text
          >
            Confirm Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toast ref="toast" />
  </span>
</template>

<script>
import VToast from '@/components/elements/Toast'
import { mapActions, mapState } from 'vuex'
import { mdiDeleteOutline } from '@mdi/js'

export default {
  name: 'DeleteUserDataDialog',

  components: {
    VToast,
  },

  data() {
    return {
      icons: {
        delete: mdiDeleteOutline,
      },
      dialog: false,
      confirmationText: '',
      confirmationError: '',
      isDeleting: false,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.users.selectedUser,
    }),

    isDeleteEnabled() {
      return this.confirmationText === 'Delete'
    },
  },

  methods: {
    ...mapActions({
      deleteUserData: 'users/deleteUserData',
    }),

    clearError() {
      this.confirmationError = ''
    },

    closeDialog() {
      this.dialog = false
      this.confirmationText = ''
      this.confirmationError = ''
    },

    async confirmDelete() {
      if (this.confirmationText !== 'Delete') {
        this.confirmationError = 'Please type "Delete" to confirm'
        return
      }

      this.isDeleting = true

      try {
        await this.deleteUserData(this.user.id)

        this.$refs.toast.open({
          color: 'success',
          message: 'User data has been deleted successfully.',
        })

        this.closeDialog()

        // Reload user profile to reflect the changes
        this.$emit('user-deleted')
      } catch (err) {
        const message =
          err.response?.data?.message ||
          'Failed to delete user data. Please try again.'
        this.$refs.toast.open({
          color: 'error',
          message: message,
        })
      } finally {
        this.isDeleting = false
      }
    },
  },
}
</script>
